import api from "../api";
import config from "../config";

export async function loadServices() {
  try {
    const res = await api.get("getProductList");

    const products = Array.isArray(res.data?.data) ? res.data.data : [];

    return products.map((item, index) => ({
      id: item.id || index + 1,
      title: item.title || "",
      subtitle: item.subtitle || "",
      category: item.category || "",
      price: Number(item.price) || 0,
      oldPrice: Number(item.oldPrice) || 0,
      discount: item.discount || "",
      weight: item.weight || "",
      image: item.image
        ? `${config.baseUrl}${item.image}`
        : "https://via.placeholder.com/300",
      rating: Number(item.rating) || 0,
      reviews: Number(item.reviews) || 0,
      tag: item.tag || "",
      description: item.description || "",
    }));
  } catch (error) {
    console.error("API Error:", error);
    return [];
  }
}
